import {_, React, observer, observable, computed, action, useLocalStore, classNames, useAsObservableSource} from '@api'
import {TabNode} from '@flexlayout'
import {} from '@blueprintjs/core'
import {IFlexLayoutTabProps} from '@stores'
import {LoadingIndicator} from '@modules'
import {IFlexLayoutIFrameTabConfig} from '@stores/catalog/flexLayout'
import * as css from './IframeFlexLayoutTab.css'

/// region Store

export const IframeFlexLayoutTabStoreContext = React.createContext<IframeFlexLayoutTabStore>(null)
export const useIframeFlexLayoutTabStore = () => React.useContext(IframeFlexLayoutTabStoreContext)

/// endregion

/// region Components

export interface IFrameFlexLayoutTabProps extends IFlexLayoutTabProps {
  className?: string
}

export class IframeFlexLayoutTabStore {
  constructor(public props: Partial<IFrameFlexLayoutTabProps>) {
  }

  @computed get tab() { return this.props.flexNode as TabNode }

  @computed get config(): Partial<IFlexLayoutIFrameTabConfig> {
    return _.merge({settings: {}}, this.tab.config as IFlexLayoutIFrameTabConfig) as Partial<IFlexLayoutIFrameTabConfig>
  }

  @action onBlurUrl = (e: React.FocusEvent<HTMLInputElement>) => {
    const newUrl = e.currentTarget.value
    this.overrideUrl = newUrl
  }

  @observable loaded = false

  @action onIframeLoad = (e: React.SyntheticEvent<HTMLIFrameElement>) => {
    console.log(`onIframeLoad`)
    const {config: {settings: {injectCss}}} = this
    if (injectCss) {
      const {currentTarget: {contentDocument}} = e
      if (!contentDocument) {
        console.debug(`Cannot inject css because we don't have access (cross-origin frame in a web browser)`)
      } else {
        const head = contentDocument.getElementsByTagName('head')[0],
          s = contentDocument.createElement('style')
        s.setAttribute('type', 'text/css')
        s.appendChild(contentDocument.createTextNode(injectCss))
        head.appendChild(s)
      }
    }

    this.loaded = true
  }

  @observable overrideUrl = ''

  @computed get url() {
    const {overrideUrl, config: {settings: {url}}} = this
    return overrideUrl || url
  }

}

export const IframeFlexLayoutTab = observer<IFrameFlexLayoutTabProps>(function IframeFlexLayoutTab({className, flexNode, ...props}) {
  const obsProps = useAsObservableSource({flexNode}),
    store = useLocalStore(() => new IframeFlexLayoutTabStore(obsProps)),
    {url, loaded} = store

  return (
    <IframeFlexLayoutTabStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)} data-loaded={loaded}>
        {!loaded && <LoadingIndicator />}
        <IFrameWithTitleBar key={url} url={url} hideTitlebar />
      </div>
    </IframeFlexLayoutTabStoreContext.Provider>)
})

export const IFrameWithTitleBar = observer<{ url: string, hideTitlebar?: boolean }>(function IFrameWithTitleBar({url, hideTitlebar}) {
  const store = useIframeFlexLayoutTabStore(),
    {onBlurUrl, onIframeLoad} = store

  return (<div className={css.frameWithTitleBar}>
    {!hideTitlebar && <div className={css.titlebar}>
      {/*<a href={url} target='_blank'>{url}</a>*/}
      <input type='search' defaultValue={url} onBlur={onBlurUrl} />
    </div>}
    <iframe src={url} className={css.iframe} onLoad={onIframeLoad}
            scrolling='auto'
            sandbox='allow-scripts allow-same-origin allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-presentation allow-top-navigation '/>
  </div>)
})
/// endregion




// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/content-panels/IframeFlexLayoutTab.tsx